// i18n/LanguageSwitcher.js
import React from 'react';
import { useI18n } from './I18nContext';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useI18n();

  return (
    <div className="lang-switcher" title="Langue / Language / ⵜⴰⵔⴰⴽⴰⵍⵜ">
      {langs.map(l => (
        <button
          key={l.lang}
          className={`lang-btn${lang === l.lang ? ' active' : ''}`}
          onClick={() => setLang(l.lang)}
          title={l.label}
        >
          <span className="lang-flag">{l.flag}</span>
          <span className="lang-code">{l.lang.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
}
